import jwtDecode from 'jwt-decode';
import { set as setCookie, get as getCookie, remove as removeCookie } from 'js-cookie'

import { IUserAuthorization, IUserInfo, UserClaims } from './model';
import { Logger } from '../logging';

const authServiceUrl = process.env.REACT_APP_INTEGRATION_USERS_URIBASE!;
const AuthenticationCookieName = 'RUSETFS_AUTHENTICATION';
const AuthorizationCookieName = 'RUSETFS_AUTHORIZATION';

export const AuthService = {
	refresh: async () => {
		Logger.logTrace('Refresh user auth')

		const jwtToken = getCookie(AuthenticationCookieName)
		if (!jwtToken)
			return;

		await signIn("auth/refresh", { authenticationToken: jwtToken });
	},

	signOut: () => {
		removeCookie(AuthenticationCookieName);
		removeCookie(AuthorizationCookieName);
	},

	signInGoogle: (jwt: string) => {
		return signIn("auth/signIn/google", { jwt });
	},
	signInYandex: (token: string) => {
		return signIn("auth/signIn/yandex", { token });
	},
	signInVkontatke: (code: string, redirectUrl: string) => {
		return signIn("auth/signIn/vkontakte", { code, redirectUrl });
	},
	signInFacebook: (token: string) => {
		return signIn("auth/signIn/facebook", { token });
	},

	resolveUserAuthenticationToken: () => {
		const jwtToken = getCookie(AuthenticationCookieName);
		if (!jwtToken)
			return null;

		return jwtToken;
	},

	resolveUserInfo: () => {
		const jwtToken = getCookie(AuthenticationCookieName)
		if (!jwtToken)
			return null;

		const decodedJwt = jwtDecode(jwtToken) as any;
		if (!decodedJwt)
			return null;

		const userInfo: IUserInfo = {
			id: decodedJwt['user.id'],
			displayName: decodedJwt['user.displayName']
		};

		return userInfo;
	},
	resolveUserAuthorization: resolveUserAuthorization
}

function resolveUserAuthorization(): IUserAuthorization {
	const jwtToken = getCookie(AuthorizationCookieName)
	if (!jwtToken)
		return { isBlocked: false, haveClaim: () => false };

	const decodedJwt = jwtDecode(jwtToken) as any;
	if (!decodedJwt)
		return { isBlocked: true, haveClaim: () => false };
	
	const isBlocked = decodedJwt['user.isBlocked'] as boolean;
	if (isBlocked)
		return { isBlocked: true, haveClaim: () => false };

	const claims = decodedJwt['claims'] as UserClaims[];
	return { isBlocked, haveClaim: claim => claims.indexOf(claim) !== -1 };
}

async function signIn(urlPart: string, body: any) {
	const singInResult = await fetch(
		authServiceUrl + urlPart,
		{
			method: 'POST',
			body: JSON.stringify(body),
			headers: { 'content-type': 'application/json' } 
		});

	const {authenticationToken, authorizationToken} = await singInResult.json();

	setCookie(AuthenticationCookieName, authenticationToken, { expires: 30, sameSite: 'lax' });
	setCookie(AuthorizationCookieName, authorizationToken, { expires: 30, sameSite: 'lax' });
}